import { BRAND_DISPLAY_NAME } from 'app-constants'

export const EVALUATION_UTILS_MODAL = {
  TITLE: 'Esse atendimento já foi avaliado!',
  DESCRIPTION: `Obrigado por avaliar o atendimento ${BRAND_DISPLAY_NAME}.`,
  BUTTON: 'Ok, entendi',
}
